import { styled } from "@mui/material/styles";
import { DataGrid } from "@mui/x-data-grid";

export const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
  border: "none",
  backgroundColor: "transparent",

  "& .MuiDataGrid-main": {
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.mode === "dark" ? theme.palette.background.paper : "#fff",
    border: `1px solid ${theme.palette.mode === "dark" ? theme.palette.grey[800] : theme.palette.grey[300]}`,
    overflow: "hidden",
    boxShadow:
      theme.palette.mode === "dark" ? "0 0 15px rgba(255,255,255,0.1)" : "0 0 15px rgba(0,0,0,0.1)",
  },

  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: theme.palette.mode === "dark" ? theme.palette.grey[800] : "#f5f5f5",
    color: theme.palette.mode === "dark" ? "#fff" : "#000",
    fontSize: "0.875rem",
    fontWeight: 600,
    borderBottom: `1px solid ${theme.palette.divider}`,
  },

  "& .MuiDataGrid-row": {
    backgroundColor: theme.palette.mode === "dark" ? theme.palette.background.paper : "#fff",
    "&:nth-of-type(even)": {
      backgroundColor:
        theme.palette.mode === "dark" ? theme.palette.grey[900] : theme.palette.grey[50],
    },
    "&:hover": {
      backgroundColor:
        theme.palette.mode === "dark" ? theme.palette.action.hover : theme.palette.grey[100],
    },
    cursor: "pointer",
    transition: "background-color 0.2s ease",
  },

  "& .MuiDataGrid-cell": {
    borderBottom: `1px solid ${theme.palette.divider}`,
    color: theme.palette.mode === "dark" ? theme.palette.text.primary : "inherit",
    fontSize: "0.875rem",
    padding: "12px 16px",
    textDecoration: "none",
  },

  "& .MuiDataGrid-columnSeparator": {
    display: "none",
  },

  "& .MuiDataGrid-menuIcon": {
    color: theme.palette.mode === "dark" ? "#fff" : "#000",
  },

  "& .MuiDataGrid-toolbarContainer": {
    padding: theme.spacing(2),
    backgroundColor:
      theme.palette.mode === "dark" ? theme.palette.grey[800] : theme.palette.grey[100],
    borderBottom: `1px solid ${theme.palette.divider}`,
  },

  "& .MuiDataGrid-footer": {
    backgroundColor:
      theme.palette.mode === "dark" ? theme.palette.grey[800] : theme.palette.grey[100],
    borderTop: `1px solid ${theme.palette.divider}`,
    color: theme.palette.text.primary,
  },

  "& .MuiCheckbox-root": {
    color: theme.palette.mode === "dark" ? theme.palette.grey[400] : theme.palette.primary.main,
  },

  "& .MuiTablePagination-root": {
    color: "inherit",
  },

  "& .MuiTablePagination-selectLabel": {
    color: "inherit",
  },

  "& .MuiTablePagination-displayedRows": {
    color: "inherit",
  },

  "& .MuiTablePagination-select": {
    color: "inherit",
  },

  "& .Mui-selected": {
    backgroundColor:
      theme.palette.mode === "dark" ? theme.palette.action.selected : theme.palette.action.selected,
    "&:hover": {
      backgroundColor:
        theme.palette.mode === "dark" ? theme.palette.action.hover : theme.palette.action.hover,
    },
  },

  "& ::-webkit-scrollbar": {
    width: "8px",
    height: "8px",
  },
  "& ::-webkit-scrollbar-track": {
    backgroundColor:
      theme.palette.mode === "dark" ? theme.palette.grey[900] : theme.palette.grey[200],
  },
  "& ::-webkit-scrollbar-thumb": {
    backgroundColor:
      theme.palette.mode === "dark" ? theme.palette.grey[600] : theme.palette.grey[400],
    borderRadius: "4px",
    "&:hover": {
      backgroundColor:
        theme.palette.mode === "dark" ? theme.palette.grey[500] : theme.palette.grey[600],
    },
  },

  "& .MuiDataGrid-footerContainer": {
    borderTop: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.mode === "dark" ? theme.palette.grey[800] : "#f5f5f5",
  },

  "& .status-chip": {
    borderRadius: "16px",
    padding: "4px 8px",
    fontWeight: 500,
  },

  "& .MuiDataGrid-row:hover": {
    textDecoration: "none",
  },

  "& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-cell:focus": {
    outline: "none",
  },

  "& .MuiDataGrid-columnHeader:focus-within, & .MuiDataGrid-cell:focus-within": {
    outline: "none",
  },

  [theme.breakpoints.down("sm")]: {
    "& .MuiDataGrid-cell": {
      padding: "8px",
      fontSize: "0.75rem",
    },
    "& .MuiDataGrid-columnHeaders": {
      minHeight: "45px !important",
      maxHeight: "45px !important",
      lineHeight: "45px !important",
      fontSize: "0.75rem",
    },
    "& .MuiDataGrid-row": {
      minHeight: "45px !important",
      maxHeight: "45px !important",
    },
    "& .status-chip": {
      height: "20px",
      fontSize: "0.65rem",
    },
    "& .MuiButtonBase-root": {
      padding: "4px",
    },
    "& .MuiDataGrid-virtualScroller": {
      minHeight: "200px !important",
    },
  },
}));
